"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "plant-nursery-table table-items-list"
  }, [_c("b-table", {
    attrs: {
      data: _vm.tableData,
      loading: _vm.isLoading,
      striped: true,
      hoverable: true,
      "mobile-cards": true
    },
    on: {
      "update:loading": function updateLoading($event) {
        _vm.isLoading = $event;
      }
    }
  }, [_c("b-table-column", {
    attrs: {
      field: "code",
      label: "Nome"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        var _props$row$code;
        return [_vm._v("\n      " + _vm._s((_props$row$code = props.row.code) !== null && _props$row$code !== void 0 ? _props$row$code : "--") + "\n    ")];
      }
    }])
  }), _vm._v(" "), _c("b-table-column", {
    attrs: {
      field: "type",
      label: "Tipo"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [_vm._v("\n      " + _vm._s(_vm.formatType(props.row.type)) + "\n    ")];
      }
    }])
  }), _vm._v(" "), _c("b-table-column", {
    attrs: {
      field: "stage",
      label: "Estágio"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        var _vm$formatStageName, _props$row$stage;
        return [_vm._v("\n      " + _vm._s((_vm$formatStageName = _vm.formatStageName((_props$row$stage = props.row.stage) === null || _props$row$stage === void 0 ? void 0 : _props$row$stage.stageName)) !== null && _vm$formatStageName !== void 0 ? _vm$formatStageName : "--") + "\n    ")];
      }
    }])
  }), _vm._v(" "), _c("b-table-column", {
    attrs: {
      field: "rootstock",
      label: "Cavalo"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        var _props$row$rootstock$, _props$row$rootstock;
        return [_vm._v("\n      " + _vm._s((_props$row$rootstock$ = (_props$row$rootstock = props.row.rootstock) === null || _props$row$rootstock === void 0 ? void 0 : _props$row$rootstock.name) !== null && _props$row$rootstock$ !== void 0 ? _props$row$rootstock$ : "--") + "\n    ")];
      }
    }])
  }), _vm._v(" "), _c("b-table-column", {
    attrs: {
      field: "scion",
      label: "Copa"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        var _ref, _props$row$scion$name, _props$row$scion, _props$row$cutting;
        return [_vm._v("\n      " + _vm._s((_ref = (_props$row$scion$name = (_props$row$scion = props.row.scion) === null || _props$row$scion === void 0 ? void 0 : _props$row$scion.name) !== null && _props$row$scion$name !== void 0 ? _props$row$scion$name : (_props$row$cutting = props.row.cutting) === null || _props$row$cutting === void 0 ? void 0 : _props$row$cutting.name) !== null && _ref !== void 0 ? _ref : "--") + "\n    ")];
      }
    }])
  }), _vm._v(" "), _c("b-table-column", {
    attrs: {
      field: "place",
      label: "Variedade"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [_vm._v("\n      " + _vm._s(_vm.formatVarietyName(props.row)) + "\n    ")];
      }
    }])
  }), _vm._v(" "), _c("b-table-column", {
    attrs: {
      field: "place",
      label: "Local"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [_vm.formatPlace(props.row.inventories).length ? _c("div", {
          staticClass: "lot-places"
        }, _vm._l(_vm.formatPlace(props.row.inventories), function (place, index) {
          return _c("div", {
            key: "".concat(props.row.id, "-").concat(index),
            staticClass: "lot-place"
          }, [_vm._v("\n          " + _vm._s(place) + "\n        ")]);
        }), 0) : _c("span", [_vm._v("--")])];
      }
    }])
  }), _vm._v(" "), _c("b-table-column", {
    attrs: {
      field: "plantedAt",
      label: "Data"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [_vm._v("\n      " + _vm._s(_vm.formatDate(props.row.plantedAt)) + "\n    ")];
      }
    }])
  }), _vm._v(" "), _c("b-table-column", {
    attrs: {
      label: "Ações"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [_c("b-dropdown", {
          attrs: {
            position: "is-bottom-left"
          }
        }, [_c("b-button", {
          staticClass: "is-text",
          attrs: {
            slot: "trigger",
            "icon-right": "dots-vertical"
          },
          slot: "trigger"
        }), _vm._v(" "), _c("b-dropdown-item", {
          on: {
            click: function click($event) {
              return _vm.$emit("open-edit", props.row);
            }
          }
        }, [_vm._v("\n          Gerenciar Lote\n        ")]), _vm._v(" "), _c("b-dropdown-item", {
          on: {
            click: function click($event) {
              return _vm.$emit("open-add-row", props.row);
            }
          }
        }, [_vm._v("\n          Criar nova rua\n        ")])], 1)];
      }
    }])
  })], 1)], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;